/* Dream Walker theme — small, dependency-free enhancements.
   Everything works without JS; this adds the mobile menu,
   live variant switching and quantity auto-update. */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    var closeBtn = drawer.querySelector('[data-menu-close]');

    function focusables() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled])')
      );
    }
    function open() {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('menu-open');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('menu-open');
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) {
      if (mq.matches && !drawer.hidden) close();
    });
  }

  /* ---------- Product variant picker ---------- */
  function initProduct(section) {
    var dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var colorIndex = data.colorIndex;
    var fieldsets = section.querySelectorAll('fieldset[data-option-index]');
    if (!fieldsets.length) return;

    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');
    var baseUrl = section.getAttribute('data-url');
    var sizeIndex = -1;

    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && /^\s*SIZES?\b/i.test(legend.textContent)) {
        sizeIndex = parseInt(fs.getAttribute('data-option-index'), 10);
      }
    });

    function selectedOptions() {
      var opts = [];
      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        var checked = fs.querySelector('input:checked');
        opts[idx] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    function markUnavailable(opts) {
      // Strike through values that are sold out given the other current selections.
      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        if (idx === colorIndex) return;
        fs.querySelectorAll('input[data-option-input]').forEach(function (input) {
          var trial = opts.slice();
          trial[idx] = input.value;
          var v = findVariant(trial);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);

      section.querySelectorAll('[data-option-value]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-value'), 10);
        if (opts[idx] == null) return;
        var inLegend = el.closest('legend');
        el.textContent = inLegend ? opts[idx].toUpperCase() : opts[idx];
      });

      if (colorIndex > -1 && opts[colorIndex] != null) {
        section.querySelectorAll('[data-color-art]').forEach(function (el) {
          el.hidden = el.getAttribute('data-color-art') !== opts[colorIndex];
        });
      }

      markUnavailable(opts);

      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-unavailable');
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = (variant.compare ? '<s class="price-pill__compare">' + escapeHtml(variant.compare) + '</s> ' : '') + escapeHtml(variant.price);
      }
      if (variant.available) {
        addBtn.disabled = false;
        var suffix = sizeIndex > -1 && opts[sizeIndex] ? ' — ' + opts[sizeIndex].toUpperCase() : '';
        addBtn.innerHTML = escapeHtml(addBtn.getAttribute('data-label-add')) + '<span data-size-suffix>' + escapeHtml(suffix) + '</span>';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-sold-out');
      }
      if (baseUrl && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-option-input')) update();
    });
    markUnavailable(selectedOptions());
  }

  /* ---------- Cart quantity input auto-submit ---------- */
  function initCart() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.hasAttribute('data-qty-input')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var section = form.closest('[data-cart-section]');
        if (section) section.classList.add('is-loading');
        form.submit();
      }, 400);
    });
    form.addEventListener('click', function (e) {
      var link = e.target.closest('[data-qty-change]');
      if (!link) return;
      var section = form.closest('[data-cart-section]');
      if (section) section.classList.add('is-loading');
    });
  }

  /* ---------- Login: toggle recover password ---------- */
  function initRecover() {
    var recover = document.getElementById('RecoverPassword');
    var login = document.getElementById('CustomerLogin');
    if (!recover || !login) return;
    function show(isRecover) {
      recover.hidden = !isRecover;
      login.hidden = isRecover;
    }
    if (window.location.hash === '#recover') show(true);
    document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        show(recover.hidden);
      });
    });
  }

  function init() {
    initMenu();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCart();
    initRecover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-init sections when edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
    initMenu();
  });
})();
